import React, { Component } from 'react';

import { Button, Form, FormControl, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Formik } from 'formik';
import { accountLoginFormSchema } from "./validation-rules";

import '../../styles/app-styles.scss';

class AccountLoginForm extends Component {
  onFormSubmit = (values, { setSubmitting }) => {
    this.props.onFormSubmit(values, setSubmitting);
  };

  render() {
    return (
      <div className="p-5 form-container" id="view-login-account">
        <div className="text-center">
          <h1 className="h4 text-gray-900 mb-4">Είσοδος στο λογαριασμό μου!</h1>
        </div>

        <Formik onSubmit={this.onFormSubmit}
                validationSchema={accountLoginFormSchema}
                initialValues={{}}>
          {( {values, errors, touched,
               handleChange, handleBlur, handleSubmit,
               isSubmitting }) => (
            <Form className="user" noValidate onSubmit={handleSubmit}>
              <FormGroup>
                <FormControl type="email" name="email" id="email"
                             className="form-control-user"
                             value={values.email || ''}
                             onChange={handleChange}
                             onBlur={handleBlur}
                             isInvalid={touched.email && errors.email}
                             placeholder="Διεύθυνση Email" required/>
              </FormGroup>
              <FormGroup>
                <FormControl type="password" name="password" id="password"
                             className="form-control-user"
                             value={values.password || ''}
                             onChange={handleChange}
                             onBlur={handleBlur}
                             isInvalid={touched.password && errors.password}
                             placeholder="Κωδικός" required/>
              </FormGroup>
              {
                this.props.error &&
                <div className="text-center action-error" id="view-login-account-action-error">
                  {this.props.error}
                </div>
              }
              <Button variant="primary" type="submit" id="form-submit" className="btn-user" block disabled={isSubmitting}>Είσοδος</Button>
            </Form>
          )}
        </Formik>

        <hr/>
        <div className="text-center">
          <Link to="/register" className="small">Δημιούργησε νέο λογαριασμό</Link>
        </div>
      </div>
    );
  }
}

export default AccountLoginForm;